import { render, staticRenderFns } from "./AlbumContent.vue?vue&type=template&id=1907d128&scoped=true"
import script from "./AlbumContent.vue?vue&type=script&lang=js"
export * from "./AlbumContent.vue?vue&type=script&lang=js"
import style0 from "./AlbumContent.vue?vue&type=style&index=0&id=1907d128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907d128",
  null
  
)

export default component.exports